"use client";

import { useEffect } from "react";
import type { Logger } from "@datadog/browser-logs";

export function AnalyticsProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    const appId = process.env.NEXT_PUBLIC_DATADOG_APP_ID;
    const rumToken = process.env.NEXT_PUBLIC_DATADOG_RUM_CLIENT_TOKEN;
    const logsToken = process.env.NEXT_PUBLIC_DATADOG_LOGS_CLIENT_TOKEN;

    if (process.env.NEXT_PUBLIC_VERCEL_ENV !== "production") {
      return;
    }

    if (!appId || !rumToken || !logsToken) {
      console.warn(
        "[AnalyticsProvider] Datadog env vars are missing — monitoring disabled."
      );
      return;
    }

    Promise.all([
      import("@datadog/browser-rum"),
      import("@datadog/browser-logs"),
    ]).then(([{ datadogRum }, { datadogLogs }]) => {
      datadogRum.init({
        applicationId: appId,
        clientToken: rumToken,
        site: "datadoghq.eu",
        service: "axe-logistics",
        version: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,
        env: "prod",
        sessionSampleRate: 100,
        sessionReplaySampleRate: 100,
        defaultPrivacyLevel: "mask-user-input",
      });

      datadogLogs.init({
        clientToken: logsToken,
        site: "datadoghq.eu",
        forwardErrorsToLogs: true,
        sessionSampleRate: 100,
        service: "axe-logistics",
        version: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,
        env: "prod",
      });
    });
  }, []);

  return <>{children}</>;
}

export default console as unknown as Logger;
